import React from 'react';
import { Button, Divider, Grid, Stack, ThemeProvider, Typography } from '@mui/material';
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  Toolbar,
  SaveButton,
  useEditContext,
} from 'react-admin';
import SelectEmployeeField from './components/SelectEmployeeFieldEdit';
import TerminalCloseButton from './components/TerminalCloseButton';
import TerminalOpenButton from './components/TerminalOpenButton';
import { Fragment, useState, useEffect } from 'react';
import { KeyboardBackspace, PendingActions } from '@mui/icons-material';
import BackButton from '../common/BackButton';
import { getSubmerchantInfo } from '../../services/SubMerchant';
import { getMerchantName } from '../../services/Merchant';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import TerminalTariffButton from './components/TerminalTariffButton';
import useResponsive from '../../ultis/helper/useResponsive';
import theme from '../layout/theme/Theme';
import Color from '../layout/color/Color';
import FontSize from '../layout/FontSize';

const saveButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: '1px solid Color.Main',
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};


export const TerminalEdit = (props) => {
  const smUp = useResponsive('up', 'sm');

  return (
    <ThemeProvider theme={theme}>
      <Edit {...props}>
        <SimpleForm toolbar={<CustomToolbar />}>
          <Grid container sx={{ justifyContent: `${smUp ? 'space-between' : ''}`, mb: 2 }}>
            <Button
              endIcon={<PointOfSaleIcon sx={{ color: Color.Main }} />}
              sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
              size="medium"
            >
              <Typography variant="h3">Edit Terminal</Typography>
            </Button>
            <Stack direction="row" spacing={3}>
              <TerminalTariffButton />
              <StatusActions />
            </Stack>
          </Grid>
          <Divider sx={{ width: '100%', mb: 3 }} />
          <MerchantName />
          <Grid container sx={{ pt: '3rem' }} justifyContent="space-between">
            <Grid item xs={12} sm={12} md={5}>
              <TextInput required source="alias" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={12} sm={12} md={5} >
              <SelectEmployeeField />
            </Grid>
            <Grid item md={5} sm={12} xs={12}>
              <ReferenceInput source="submerchantID" reference="SubMerchant" filter={{status: 1}}>
                <AutocompleteInput
                  optionText="name"
                  source="submerchantID"
                  fullWidth
                  variant="outlined"
                  label="Submerchant"
                />
              </ReferenceInput>
            </Grid>
          </Grid>
        </SimpleForm>
      </Edit>
    </ThemeProvider>

  );
};

const StatusActions = () => {
  const { record } = useEditContext();
  return (
    <Fragment>
      {record.status === 1 ? (
        <TerminalCloseButton />
      ) : record.status === 2 ? (
        <Button
          size="large"
          startIcon={<PendingActions />}
          color="info"
          disabled
          variant='contained'
        >
          Pending
        </Button>
      ) : (
        <TerminalOpenButton />
      )}
    </Fragment>
  );
};

const CustomToolbar = (props) => {
  return (
    <Toolbar
      {...props}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <BackButton variant="outlined" startIcon={<KeyboardBackspace />} sx={backButton} />
      <SaveButton sx={saveButton} />
    </Toolbar>
  );
};

const MerchantName = () => {
  const { record } = useEditContext();
  const [merchantName, setMerchantName] = useState('');
  useEffect(() => {
    const getData = async () => {
      const submerchantInfo = await getSubmerchantInfo(record.submerchantID);
      const tmpMerchantName = await getMerchantName(
        parseInt(submerchantInfo.merchantID)
      );
      setMerchantName(tmpMerchantName);
    };

    getData();
  }, [record]);

  return (
    <Typography fontSize="1.3rem" pl="1rem">
      Merchant: <strong>{merchantName}</strong>
    </Typography>
  );
};
